import type { ReactNode } from "react";
import { cn } from "../../lib/cn";

export function EmptyState({
  title,
  description,
  className,
  children,
}: {
  title: string;
  description?: string;
  className?: string;
  children?: ReactNode;
}) {
  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center p-8 text-center",
        className,
      )}
    >
      {children}
      <p className="font-headline-md text-headline-md text-on-surface">{title}</p>
      {description ? (
        <p className="text-body-sm text-on-surface-variant mt-2 max-w-md">{description}</p>
      ) : null}
    </div>
  );
}
